import axios from "axios";
import Config from "src/config";

const v1_actionCriarFluxoDireto = (data) => {
    
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/fluxos/criar`,
        data
    });
};

export default v1_actionCriarFluxoDireto;
